export const isImageIcon = (icon) => icon?.startsWith('http') || icon?.startsWith('data:image');
